import { hasRoleInDistrict, type CurrentUserDto, type MembershipRole } from '../../shared/auth/useCurrentUser'

/**
 * Minimum role required to see a nav item / reach a route, keyed by nav-item id.
 * An id that is absent here is unrestricted (visible to any signed-in user).
 * Single source of truth shared by the nav (this filters the sidebar) and the
 * route gate (see features/_shell/routes.tsx).
 */
export const ROUTE_MIN_ROLE: Record<string, MembershipRole> = {
  calendar: 'Admin',
  messages: 'Admin',
  seasons: 'Admin',
  administration: 'Admin',
  impersonate: 'SuperAdmin',
}

/** Whether `user` may see the nav item / route `id`, evaluated in the ACTIVE district. */
export function canSee(user: CurrentUserDto | undefined, id: string, activeDistrictId: string | null): boolean {
  const min = ROUTE_MIN_ROLE[id]
  if (!min) return true
  return hasRoleInDistrict(user, activeDistrictId, min)
}
